import { useEffect } from "react"
import constants from "../../constants/constants"
import { CommaSeparator, DateToPersianNumber, ToPersianNumber } from "../../functions"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useState } from "react"
import './style.scss'
import Table from "react-bootstrap/Table";
import { wordifyRials } from "../../functions/extensions/wordififa";
import { NotLogin, ErrorToast } from "../../shared/index";


const InvoiceOfUser = ({ itemOfTable, setShowPdf }) => {



    const [myDate, setMyDate] = useState('')




    useEffect(() => {
        let tempDate = itemOfTable?.PersianIssueDate ? itemOfTable?.PersianIssueDate.split(' ') : '---'
        setMyDate(tempDate[0])
        html2canvas(document.getElementById("invoice-factor"),
            {
                onclone: function (clonedDoc) {
                    clonedDoc.getElementById('invoice-factor').style.display = 'block';
                }
            }
        ).then(canvas => {
            var pdf = new jsPDF('l', 'pt', [canvas.width, canvas.height]);
            var imgData = canvas.toDataURL("PNG", 1.0);
            pdf.addImage(imgData, 0, 0, (canvas.width), (canvas.height));
            pdf.save('converteddoc.pdf');
            setShowPdf()
        });

    }, [])

    return (
        <>
            <main className="invoice invoice-factor-holder" id="invoice-factor">
                <div id="invoice-factor" className="invoice-factor">
                    {itemOfTable?.Revoked && <div className="revoked">باطل شده</div>}
                    <Table className="table-invoice-holder">
                        <tbody>
                            <tr className="first-row" >
                                <th colSpan="19" rowSpan="3">{constants.InvoiceSaleServiceOrGoods}</th>
                                <td colSpan="1">{constants.SerialNumber}</td>
                                <td colSpan="3">{itemOfTable?.InvoiceNumberInFactor}</td>
                            </tr>
                            <tr className="first-row" >
                                <td colSpan="1">
                                    {constants.Date}</td>
                                <td colSpan="3">
                                    {itemOfTable?.PersianIssueDate ? itemOfTable?.PersianIssueDate.split(' ')[0] : '---'
                                    }
                                </td>
                            </tr>
                            <tr className="first-row" >
                                <td colSpan="1" >{constants.ReferenceNumber}</td>
                                <td colSpan="3" >{!itemOfTable?.Revoked ?
                                    itemOfTable?.MoadianTaxId !== null && itemOfTable?.MoadianTaxId !== '' ? itemOfTable?.MoadianTaxId : '----------' :
                                    itemOfTable?.ParentTaxId !== null && itemOfTable?.ParentTaxId !== '' ? itemOfTable?.ParentTaxId : '-----------'}</td>
                            </tr>
                            <tr>
                                <th calassName="invoice-factor-title" colSpan="20">
                                    {constants.SELER_INFO}
                                </th>
                            </tr>
                            <tr className="seller-buyer-tr-info  seller-buyer-info">
                                <td colSpan="24" >
                                    <div className="d-flex flex-row justify-content-between" style={{ padding: '5px' }}>
                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.PERSON_NAME_LBL}:</label>
                                            <label>{constants.DaftareShomaCompany}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.NUMBER_ECONOMI_LBL}:</label>
                                            <label>{constants.DaftareShmaEconomicNumber}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.REGISTER_CODE_LBL}:</label>
                                            <label>{constants.DaftareShomaRegisterCode}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start   last-cell-in-invoice-info" style={{ marginLeft: '10%' }}>
                                            <label>{constants.NATIONAL_CODE_LBL}:</label>
                                            <label>{constants.DaftareShmanatioNalCode}</label>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between" style={{ padding: '5px' }}>
                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.ADRESS_LBL}:</label>
                                            <label>{constants.DaftareShomaAddress}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.POSTAL_CODE_LBL}:</label>
                                            <label>{constants.DaftareShomaPostalCode}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.PHONE_LBL}:</label>
                                            <label>{constants.DaftareShomaPhone}</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start last-cell-in-invoice-info" style={{ marginLeft: '10%' }}>
                                            <label>{constants.FAX_LBL}:</label>
                                            <label>{constants.DaftareshomaFax}</label>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                            <tr>
                                <th colSpan="24">
                                    {constants.BUYER_INFO}
                                </th>
                            </tr>
                            <tr className="seller-buyer-tr-info  seller-buyer-info">
                                <td colSpan="24" >
                                    <div className="d-flex flex-row justify-content-between  row-padding-invoice" >
                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.PERSON_NAME_LBL}:</label>
                                            <label>{
                                                itemOfTable?.FactorIssueType === 2 ? itemOfTable?.CompanyName ? itemOfTable?.CompanyName : '---' : itemOfTable?.FirstNameAndLastName !== null ? itemOfTable?.FirstNameAndLastName : '---'
                                            }</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.NUMBER_ECONOMI_LBL}:</label>
                                            <label>{
                                                itemOfTable?.FactorIssueType === 2 ? itemOfTable?.CompanyEconomicCod ? itemOfTable?.CompanyEconomicCod : '---' : '----'

                                            }</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start last-cell-in-invoice-info">
                                            <label>{constants.REGISTER_CODE_LBL}:</label>
                                            <label>{
                                                itemOfTable?.FactorIssueType === 2 ? itemOfTable?.NationalCompanyRegistrationNumber : itemOfTable?.NationalCode !== null ? itemOfTable?.NationalCode : '---'
                                            }</label>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between row-padding-invoice" >
                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.PROVINCE_ADDRESS_LBL}:</label>
                                            <label>{
                                                itemOfTable?.ProvinceName ?? '---'
                                            }</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.POSTAL_CODE_LBL}:</label>
                                            <label>{
                                                itemOfTable?.FactorIssueType === 2 ? itemOfTable?.WorkPostalCode : itemOfTable?.ResidencePostalCode !== null ? itemOfTable?.ResidencePostalCode : '---'
                                            }</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start last-cell-in-invoice-info">
                                            <label>{constants.CITY_LBL}:</label>
                                            <label>{
                                                itemOfTable?.CityName ?? '---'
                                            }</label>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row justify-content-between row-padding-invoice" >
                                        <div className="d-flex flex-row justify-content-start">
                                            <label>{constants.ADRESS_LBL}:</label>
                                            <label>
                                                {itemOfTable?.FactorIssueType === 2 ? itemOfTable?.WorkAddress : itemOfTable?.ResidenceAddress !== null ? itemOfTable?.ResidenceAddress : '---'
                                                }</label>
                                        </div>

                                        <div className="d-flex flex-row justify-content-start last-cell-in-invoice-info">
                                            <label>{constants.PHONE_LBL}:</label>
                                            <label>{
                                                itemOfTable?.Phone ?? '---'
                                            }</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th colSpan="24">
                                    {constants.GOODS_INFO}
                                </th>
                            </tr>
                            <tr className="price-invoice">
                                <td colSpan="1">{constants.ROW_NUMBER}</td>
                                <td colSpan="1">{constants.GOODS_CODED}</td>
                                <td colSpan="2">{constants.EXPLAIN_GOODS}</td>
                                <td colSpan="1">{constants.COUNT_OR_AMOUNT}</td>
                                <td colSpan="1">{constants.UNIT}</td>
                                <td colSpan="5">{constants.PRICE_UNIT}</td>
                                <td colSpan="6">{constants.TOTAL_PRICE}</td>
                                <td colSpan="1">{constants.DISCOUNT_PRICE}</td>
                                <td colSpan="1">{constants.ADD_PRICE}</td>
                                <td colSpan="1">{constants.TOTAL_PRICE_AFTER_DSCOUNT_ADD}</td>
                                <td colSpan="1">{constants.SUM_TAX}</td>
                                <td colSpan="2">{constants.NetInvoice}</td>
                            </tr>
                            <tr className="price-invoice">
                                <td colSpan="1">1</td>
                                <td colSpan="1">{itemOfTable?.ProductCode ? itemOfTable?.ProductCode : '---'}</td>
                                <td colSpan="2">{itemOfTable?.InvoiceItemDescription ? itemOfTable?.InvoiceItemDescription : 0} </td>
                                <td colSpan="1">1</td>
                                <td colSpan="1">{constants.Number}</td>
                                <td colSpan="5">{itemOfTable?.Subtotal ? CommaSeparator(itemOfTable?.Subtotal * 10) : 0} </td>
                                <td colSpan="6">{itemOfTable?.Subtotal ? CommaSeparator(itemOfTable?.Subtotal * 10) : 0} </td>
                                <td colSpan="1">{itemOfTable?.TotalDiscount ? CommaSeparator(itemOfTable?.TotalDiscount * 10) : 0} </td>
                                <td colSpan="1">{0}</td>
                                <td colSpan="1">{itemOfTable?.TotalBeforeVAT ? CommaSeparator(itemOfTable?.TotalBeforeVAT * 10) : 0}</td>
                                <td colSpan="1">{itemOfTable?.VAT ? CommaSeparator(itemOfTable?.VAT * 10) : 0}</td>
                                <td colSpan="2">{itemOfTable?.PayableAmount ? CommaSeparator(itemOfTable?.PayableAmount * 10) : 0}</td>
                            </tr>

                            <tr className="price-invoice">
                                <td colSpan="14">جمع کل</td>
                                <td colSpan="2">{itemOfTable?.Subtotal ? CommaSeparator(itemOfTable?.Subtotal * 10) : 0} </td>
                                <td colSpan="2">{itemOfTable?.TotalDiscount ? CommaSeparator(itemOfTable?.TotalDiscount * 10) : 0} </td>
                                <td colSpan="1">{0}</td>
                                <td colSpan="1">{itemOfTable?.TotalBeforeVAT ? CommaSeparator(itemOfTable?.TotalBeforeVAT * 10) : 0}</td>
                                <td colSpan="1">{itemOfTable?.VAT ? CommaSeparator(itemOfTable?.VAT * 10) : 0}</td>
                                <td colSpan="2">{itemOfTable?.PayableAmount && itemOfTable?.PayableAmount !== '---' ? CommaSeparator(itemOfTable?.PayableAmount * 10) : 0}</td>
                            </tr>
                            <tr>
                                <td className="method-sell" colSpan="14">
                                    <span className="method-sell-span" >{constants.MethodSell}:</span>
                                    <div className="d-flex flex-row justify-content-start">
                                        <div style={{ marginLeft: '50px' }}>
                                            <input type="checkbox" id="method1" name="method1" value="method1" checked={true} />
                                            <label forhtml="method1"> نقدی</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" id="method2" name="method2" value="method2" />
                                            <label forhtml="method2"> غیر نقدی</label>
                                        </div>
                                    </div>

                                </td>
                                <td colSpan="10">{wordifyRials(itemOfTable?.PayableAmount * 10)}</td>
                            </tr>
                            <tr >
                                <td colSpan="2">
                                    <div className="d-flex flex-row justify-content-start">{constants.Description}:</div>
                                </td>
                                <td colSpan="22">{itemOfTable?.Description}</td>
                            </tr>
                            <tr className="sign-invoice">
                                <td colSpan="10" >
                                    <span>
                                        <span>{constants.SignSeller}:</span>
                                        <span><img src="./azm.png" /></span>
                                    </span>
                                </td>
                                <td colSpan="14">{constants.SignBuyer}:</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </main >

        </>
    )

}

export default InvoiceOfUser